import { Grid, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useHeartRhythmOverview } from 'hooks/api/useHeartRhythmData';
import { BsHeart } from 'react-icons/bs';
import { PaperWithBorder } from 'components/PaperWithBorder';
import { DonutChart } from 'components/Charts/DonutChart/DonutChart';
import { Indicator } from 'utils/models';
import { PatientDetailsDescriptionKeys } from 'models/measurement';
import { ChartLabelPrefix } from 'models/charts';
import { HeartRateCharts } from './HeartRateCharts/HeartRateCharts';
import { ReportsOverviewList } from './ReportsOverview/ReportsOverviewList';
import { SymptomRhythmList } from './SymptomRhythmList/SymptomRhythmList';
import { PatientDetailsGrid } from '../../PatientDetailsGrid';
import { HeartRateCalendar } from './HeartRateCalendar';
import { LogsOverviewList } from './LogsOverview/LogsOverviewList';

export const HeartRateOverview = () => {
  const { t } = useTranslation();
  const { data: measurements, isLoading, distributionValues } = useHeartRhythmOverview();

  return (
    <PatientDetailsGrid
      title={t('patients_title_heartrate')}
      Icon={BsHeart}
      pageDescriptionKey={PatientDetailsDescriptionKeys.HeartRate}
    >
      <Grid.Col span={7}>
        <Stack>
          <HeartRateCharts />
          <ReportsOverviewList />
          <LogsOverviewList />
        </Stack>
      </Grid.Col>
      <Grid.Col span={5}>
        <Stack>
          <PaperWithBorder
            isLoading={isLoading}
            title={t('patients_measurements_title')}
            testId={'donut-chart-measurements'}
          >
            <DonutChart<Indicator> data={distributionValues} labelPrefix={ChartLabelPrefix.Indicator} />
          </PaperWithBorder>
          <SymptomRhythmList measurements={measurements} />
        </Stack>
      </Grid.Col>
      <Grid.Col span={12}>
        <HeartRateCalendar />
      </Grid.Col>
    </PatientDetailsGrid>
  );
};
